import { useEffect } from 'react';

import { useScaSubject } from '../../providers/ScaSubjectProvider/ScaSubjectProvider.hooks';

export const useLimitExceededRedirect = (isLimitExceeded: boolean) => {
  const { refetchSubject } = useScaSubject();

  useEffect(() => {
    if (isLimitExceeded) {
      refetchSubject();
    }
  }, [isLimitExceeded, refetchSubject]);
};
